package com.flowyride.core.map

import com.flowyride.core.domain.model.GeoPoint

/**
 * @param id Stable identity: keeps a marker's drag state across recompositions and reorderings.
 * @param label Short text drawn inside the marker (e.g. the stop number).
 */
data class MapMarker(
    val id: String,
    val point: GeoPoint,
    val kind: Kind,
    val label: String? = null,
    /** Fixed markers ignore drags (read-only rides). */
    val draggable: Boolean = true,
) {
    enum class Kind { DEPARTURE, STOP, ARRIVAL }
}
